import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class GestionTitreService {
  constructor(
    private readonly titleService: Title,
    private readonly translateService: TranslateService
  ) {}

  addTitreOnglet(dcr: string) {
    this.translateService.get(dcr).subscribe((texte: string) => this.titleService.setTitle(texte));
  }
}
